export default __webpack_public_path__ + "static/media/header-volunteer.d18f73a2.png";